import type { ReactNode } from 'react';
import { Card, Space, Typography } from 'antd';

const TONES: Record<string, string> = {
  indigo: '#6366f1',
  violet: '#7c3aed',
  amber:  '#f59e0b',
  sky:    '#0ea5e9',
  slate:  '#64748b',
};

interface Props {
  tone: keyof typeof TONES;
  icon: ReactNode;
  title: string;
  desc?: string;
  actions?: ReactNode;
  children: ReactNode;
}

export function SectionCard({ tone, icon, title, desc, actions, children }: Props) {
  return (
    <Card style={{ marginBottom: 20 }} styles={{ body: { paddingTop: 12 } }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
        <div
          style={{
            width: 36, height: 36, borderRadius: 10, flex: '0 0 auto',
            background: TONES[tone], color: '#fff',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
          }}
        >
          {icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Typography.Text strong style={{ fontSize: 16 }}>{title}</Typography.Text>
          {desc && (
            <div>
              <Typography.Text type="secondary" style={{ fontSize: 13 }}>{desc}</Typography.Text>
            </div>
          )}
        </div>
        {actions && <Space>{actions}</Space>}
      </div>
      {children}
    </Card>
  );
}
